// extracted by mini-css-extract-plugin
export default {"linkGuide":"LinkGuide_linkGuide__OdSof","linkGuideHeader":"LinkGuide_linkGuideHeader__yFO0I"};